










export default
  mounted: () ->
    document.querySelector('html, body').style.overflowY = 'hidden'
    document.querySelector('.scroll_area').addEventListener('scroll', @scroll)
    document.querySelector('#section_flow').style.display = 'none'
  beforeDestroy: () ->
    document.querySelector('#section_flow').style.display = 'block'
    document.querySelector('html, body').style.overflowY = 'scroll'
    if window.innerWidth > 750
      document.querySelector('#section_flow').style.display = 'flex'
  methods: 
    close: () ->
      @$emit('close')
